import { Navigate, useParams } from 'react-router';

import { ClientCommunicationDrawer } from '@/components/comments/ClientCommunicationDrawer/ClientCommunicationDrawer';
import { BrandRequestContextProvider } from '@/layouts/Brand/BrandRequestContext';
import {
  BrandRequestLayout,
  BrandRequestMain,
  BrandRequestMainHeader,
  BrandRequestSidebar,
  BrandRequestSidebarContent,
  BrandRequestSidebarFooter,
} from '@/layouts/Brand/BrandRequestLayout/BrandRequestLayout';
import { useProductAttributesByArticle } from '@/models/productAttribute';
import { useClientRequest } from '@/models/request';
import { useWorkflowPublic } from '@/models/workflow';
import { useClientToken, useStoreToken } from '@/services/auth';
import useViewPort from '@/utils/useViewport';

import ClientRequestView from './components/ClientRequestView';
import { ContactAfterSales } from './components/shared/ContactAfterSales';
import { RequestInfo } from './components/shared/RequestInfo';
import StoreRequestView from './components/StoreRequestView';

const ClientRequest = () => {
  const { isMobile } = useViewPort();
  const { id } = useParams();

  const { data: request, isLoading: isRequestLoading } = useClientRequest(id);
  const { data: workflow } = useWorkflowPublic(request?.workflowId);
  const clientToken = useClientToken();
  const storeToken = useStoreToken();
  const productAttributesByArticle = useProductAttributesByArticle(request);

  if (isRequestLoading) {
    return (
      <BrandRequestLayout>
        {!isMobile && <BrandRequestSidebar />}
        <BrandRequestMain>{isMobile && <BrandRequestMainHeader />}</BrandRequestMain>
      </BrandRequestLayout>
    );
  }

  if (!id || !request || (!clientToken && !storeToken)) {
    return <Navigate to="../error" />;
  }

  const showContactAfterSales =
    !!clientToken && !!request.organization.config.clientCommunication?.chat?.enabled;

  return (
    <BrandRequestContextProvider
      request={request}
      workflow={workflow}
      productAttributesData={productAttributesByArticle ?? []}
    >
      <BrandRequestLayout>
        {!isMobile && (
          <>
            <BrandRequestSidebar>
              <BrandRequestSidebarContent>
                <RequestInfo />
              </BrandRequestSidebarContent>
              {showContactAfterSales && (
                <BrandRequestSidebarFooter>
                  <ContactAfterSales />
                </BrandRequestSidebarFooter>
              )}
            </BrandRequestSidebar>
          </>
        )}

        <BrandRequestMain>
          {isMobile && (
            <BrandRequestMainHeader>
              {showContactAfterSales && <ContactAfterSales />}
            </BrandRequestMainHeader>
          )}
          {!!clientToken && <ClientRequestView />}
          {!!storeToken && <StoreRequestView />}
        </BrandRequestMain>

        <ClientCommunicationDrawer />
      </BrandRequestLayout>
    </BrandRequestContextProvider>
  );
};

export default ClientRequest;
